/**
** 专家登录界面--项目评估-已完成项目
 */
<template>
    <div id="completeProject" class="jc-page">
        <div class="jc-panel jc-page-head">
			<span class="header-title">{{ headerTitle }}</span>
            <div class="header-operation">
                <el-form ref="form" :model="form">
                    <el-form-item>
                        <el-input v-model="form.checkup_project_name" placeholder="项目名称"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="form.attr" placeholder="归属地">
                            <el-option 
                                v-for="item in attrOptions" 
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-date-picker
                            v-model="form.start_date"
                            type="year"
                            placeholder="开始时间">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-date-picker
                            v-model="form.end_date"
                            type="year"
                            placeholder="结束时间">
                        </el-date-picker>
                    </el-form-item>  
                        <el-button class="button" @click="query">查询</el-button>
                </el-form>
            </div>
        </div>
        <div class="jc-table-container jc-scroll-panel" style="padding:0px;background:#f3f3f3;">
            <div style="width:calc(100% - 20px);text-align:left;padding:10px;">
                <el-card style="margin:10px;width:calc(25% - 22px);display:inline-block;float:none;font-size:14px;color:#101010;" v-for="(item,i) in cardDate" :key="i" class="box-card" @click.native="goProjectEval(item)">
                    <div slot="header" class="clearfix">
                        <span>{{item.checkup_project_name}}</span>
                    </div>
                    <div class="text item">
                        <span class="projectType">{{item.organization_name}}</span>
                    </div>
                    <div class="text item">
                        <span>评估类型：{{item.evaluation_type_name}}</span>
                    </div>
                    <div class="text item">
                        <span>项目周期：{{item.start_date + '年至'+item.end_date+'年'}}</span>
                    </div>
                </el-card>
            </div>
        </div>
    </div>  
</template>
<script>
import {eventBus} from '../../../eventbus/index'
import {getFinishCheckupProjectList} from '@/apis/projects'
export default {
    name:"CompleteProject",
    data(){
        return {
            currentPage:1,// 当前页数
            count:1000,//表格页数
            total:0,// 总条目数
            headerTitle:'已完成项目',
            attrOptions:[
                {
                    value:'西安',
                    label:'西安'
                }
            ], // 进行中项目-头部“归属地”选择
            form:{
                checkup_project_name:"",
                attr:"",
                start_date:"",
                end_date:""
            }, // 头部右侧表单内容
            cardDate:[], // 卡片内容 
        }
    },
    mounted(){
        this.loadData()
    },
    methods:{
        query(){
            this.loadData()
        },
        loadData(){
            getFinishCheckupProjectList({
                "checkup_project_name" : this.form.checkup_project_name,
                "start_date" : this.form.start_date,
                "end_date" : this.form.end_date,
                "pagination" : {
                    "page" : this.currentPage,
                    "count" : this.count
                }
            }).then(res=>{
                this.cardDate = res.data.data.checkup_project_list
            })
        },
        // 点击card卡片，跳转至项目详情界面
        goProjectEval(val){
            console.log('进行中项目详情',val);
            // this.display = 'block';
            // this.goDisplay = 'none';
            this.$router.push('/projectEval/CompleteProDetail/' + val.checkup_project_id);
        },
    }
}
</script>
<style scoped>
#completeProject{
    position: relative;
}
.header {
    width: 100%;
    height: 35px !important;
    border-bottom: 1px solid #ccc;
}
.header-left {
    width: 200px;
    text-align: left;
    position: absolute;
}
.header-title {
    font-weight: bold;
}
.header-right {
    position: absolute;
    right: 20px;
    /* width: 55%; */
    height: 35px;
    top: -15px;
}
.el-form{
    display: flex;
    height: 35px;
}
.el-form-item {
    width: 180px;
    margin-right: 10px;
}
.button {
    height: 38px;
    color: #fff;
    background-color: #000;
}
#completeProject >>> .el-input__inner {
    height: 35px;
    padding: 0 10px;
    border: 1px solid #000;
}
#completeProject >>> .el-input input::-webkit-input-placeholder{
    color: #9e9fa3;
}
/* 头部右边-时间选择 */
#completeProject >>> .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
}
#completeProject >>> .el-date-editor .el-input__prefix{
    left: 0px;
}
#completeProject >>> .el-date-editor .el-input__inner {
    padding-left: 20px;
}
/* 主内容样式 --card卡片*/
.projectMain {
    background-color: #f3f3f3;
    height: calc(100vh - 136px);
    width: 100%;
}
#completeProject >>> .el-main {
    padding: 15px;
}
.projectMain .text {
    font-size: 14px;
}
.item {
    margin-bottom: 10px;
}
.item .projectType {
    border: 2px solid #ccc;
    padding: 3px 5px;
    box-sizing: border-box;
}
.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}
.clearfix:after {
    clear: both
}
.box-card {
    width: 24%;
    height: 180px;
    float: left;
    margin-right: 10px;
}
#completeProject >>> .el-card__header {
    padding: 10px 20px;
    text-align: left;
    padding-top: 20px;
    font-weight: bold;
    border-bottom: none;
}
#completeProject >>> .el-card__body {
    padding: 0 20px;
    text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/views/Expert/CompleteProject/CompleteProject.vue